var map = {
	"./site-logo-desktop-alt.svg": 89757,
	"./site-logo-desktop-footer.svg": 84373,
	"./site-logo-desktop.svg": 54947,
	"./site-logo-drawer-mobile.svg": 68301,
	"./site-logo-drawer.svg": 84174,
	"./site-logo-mobile-drawer.svg": 87615,
	"./site-logo-mobile.svg": 84119,
	"./site-logo-sm.svg": 27981,
	"./site-logo-wrapper-mobile-scrolled.svg": 99082,
	"./site-logo-wrapper-mobile.svg": 76581,
	"./site-logo-wrapper-scrolled.svg": 13047,
	"./site-logo-wrapper.svg": 27718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37663;